// Global Google Maps loader to ensure Maps API is available app-wide
// This replaces the component-specific loading in RecipientSection.js

let isLoading = false;
let isLoaded = false;

export const loadGoogleMaps = () => {
  return new Promise((resolve, reject) => {
    // Already loaded
    if (window.google?.maps) {
      console.log('🎉 Google Maps already available');
      resolve();
      return;
    }

    // Already loading
    if (isLoading) {
      console.log('⏳ Google Maps already loading, waiting...');
      const checkLoaded = () => {
        if (window.google?.maps) {
          resolve();
        } else {
          setTimeout(checkLoaded, 100);
        }
      };
      checkLoaded();
      return;
    }

    // Get API key
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      reject(new Error('Google Maps API key not found'));
      return;
    }

    console.log('📡 Loading Google Maps globally...');
    isLoading = true;

    // Check if script already exists
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      console.log('🔄 Removing existing Google Maps script');
      existingScript.remove();
    }

    // Create callback function
    const callbackName = 'initGoogleMapsGlobal';

    window[callbackName] = () => {
      console.log('✅ Google Maps loaded globally!');
      isLoaded = true;
      isLoading = false;

      // Dispatch event for components that are listening
      window.dispatchEvent(new Event('google-maps-loaded'));

      // Clean up callback
      delete window[callbackName];

      resolve();
    };

    // Create and load script with proper async loading
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=${callbackName}`;
    script.async = true;
    script.defer = true;

    script.onerror = () => {
      console.error('❌ Failed to load Google Maps');
      isLoading = false;
      delete window[callbackName];
      reject(new Error('Failed to load Google Maps'));
    };

    document.head.appendChild(script);
  });
};

// Auto-load Google Maps when this module is imported
loadGoogleMaps().catch(error => {
  console.error('Failed to auto-load Google Maps:', error);
});

export default loadGoogleMaps;